import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Retry only network errors / 5xx — never 4xx (auth, validation, 404).
      retry: (failureCount, err) =>
        (err?.status === 0 || err?.status >= 500) && failureCount < 2,
      refetchOnWindowFocus: true,
    },
  },
});
